
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matkaajat/[slug]",
      function () {
        return require("private-next-pages/matkaajat/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matkaajat/[slug]"])
      });
    }
  